var _path, _path2, _path3, _path4, _path5, _path6, _path7, _linearGradient, _path8, _path9, _path10, _path11, _path12, _linearGradient2, _path13, _linearGradient3, _path14, _linearGradient4, _path15, _linearGradient5, _polygon, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8PinPad50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#35c1f1",
    d: "M29,28H14c-2.761,0-5-2.239-5-5V8c0-2.761,2.239-5,5-5h15c2.761,0,5,2.239,5,5v15 C34,25.761,31.761,28,29,28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#125999",
    d: "M20,11h3c0.552,0,1-0.448,1-1V7c0-0.552-0.448-1-1-1h-3c-0.552,0-1,0.448-1,1v3 C19,10.552,19.448,11,20,11z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#125999",
    d: "M27,11h3c0.552,0,1-0.448,1-1V8c0-1.105-0.895-2-2-2h-2c-0.552,0-1,0.448-1,1v3 C26,10.552,26.448,11,27,11z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#125999",
    d: "M13,11h3c0.552,0,1-0.448,1-1V7c0-0.552-0.448-1-1-1h-2c-1.105,0-2,0.895-2,2v2 C12,10.552,12.448,11,13,11z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#125999",
    d: "M20,18h3c0.552,0,1-0.448,1-1v-3c0-0.552-0.448-1-1-1h-3c-0.552,0-1,0.448-1,1v3 C19,17.552,19.448,18,20,18z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#125999",
    d: "M27,18h3c0.552,0,1-0.448,1-1v-3c0-0.552-0.448-1-1-1h-3c-0.552,0-1,0.448-1,1v3 C26,17.552,26.448,18,27,18z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#125999",
    d: "M13,18h3c0.552,0,1-0.448,1-1v-3c0-0.552-0.448-1-1-1h-3c-0.552,0-1,0.448-1,1v3 C12,17.552,12.448,18,13,18z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "4J2xu_HwP6QCI_Xo1vfJGa",
    x1: 19,
    x2: 24,
    y1: 25.5,
    y2: 25.5,
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d61a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16528c"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#4J2xu_HwP6QCI_Xo1vfJGa)",
    d: "M20,25h3c0.552,0,1-0.448,1-1v-3c0-0.552-0.448-1-1-1h-3c-0.552,0-1,0.448-1,1v3 C19,24.552,19.448,25,20,25z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#125999",
    d: "M27,25h2c1.105,0,2-0.895,2-2v-2c0-0.552-0.448-1-1-1h-3c-0.552,0-1,0.448-1,1v3 C26,24.552,26.448,25,27,25z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#125999",
    d: "M14,25h2c0.552,0,1-0.448,1-1v-3c0-0.552-0.448-1-1-1h-3c-0.552,0-1,0.448-1,1v2 C12,24.105,12.895,25,14,25z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25,18.5V28h-7v-9.5c0-1.93,1.57-3.5,3.5-3.5S25,16.57,25,18.5z",
    opacity: 0.05
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5,18.5V28h-6v-9.5c0-1.65,1.35-3,3-3S24.5,16.85,24.5,18.5z",
    opacity: 0.07
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "4J2xu_HwP6QCI_Xo1vfJGb",
    x1: 12.98,
    x2: 12.982,
    y1: -47.819,
    y2: -47.819,
    gradientTransform: "rotate(9.32 -498.615 -28.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f8bd29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0b421"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#4J2xu_HwP6QCI_Xo1vfJGb)",
    d: "M9.36,35.275c0.001-0.007,0.004-0.012,0.005-0.019l-0.002-0.001L9.36,35.275z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "4J2xu_HwP6QCI_Xo1vfJGc",
    x1: 13.833,
    x2: 19.276,
    y1: -94.618,
    y2: -99.985,
    gradientTransform: "translate(0 134)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    stopColor: "#ffc430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#f8bd2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    stopColor: "#e5aa23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#c58a14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c6000"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#4J2xu_HwP6QCI_Xo1vfJGc)",
    d: "M11.44,32C9.602,32,9,33.744,9,35l9.657,9.657c0.11,0.11,0.228,0.208,0.343,0.311v-9.329 C15,33,12.414,32,11.44,32z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "4J2xu_HwP6QCI_Xo1vfJGd",
    x1: 20.849,
    x2: 41.767,
    y1: -103.425,
    y2: -81.701,
    gradientTransform: "translate(0 134)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fec130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#fcb730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#f7a72f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a72f"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#4J2xu_HwP6QCI_Xo1vfJGd)",
    d: "M34.738,30.902L24,29V18.643c0-1.308-0.941-2.499-2.242-2.63C20.261,15.863,19,17.034,19,18.5 c0,2.237,0,2.237,0,26.468c1.461,1.3,1.347,2.032,3.314,2.032H33c3.314,0,6-2.686,6-6v-5.153C39,33.371,37.188,31.268,34.738,30.902 z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "4J2xu_HwP6QCI_Xo1vfJGe",
    x1: 24.894,
    x2: 23.145,
    y1: -101.987,
    y2: -102.939,
    gradientTransform: "translate(0 134)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    stopColor: "#ffc430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#f8bd2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    stopColor: "#e5aa23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#c58a14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c6000"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#4J2xu_HwP6QCI_Xo1vfJGe)",
    points: "24,29 24,35 26.579,29.457"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 18.5,
    r: 1.5,
    fill: "#fff0c9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8PinPad50);
export default __webpack_public_path__ + "static/media/icons8-pin-pad-50.3049ab9327038a0e4a7b295645ff3a8f.svg";
export { ForwardRef as ReactComponent };